import * as React from 'react';

import { ButtonDefault } from '@ui';

export const PaymentGoBackButton = ({ onClick, children }: {onClick(): void; children: React.ReactNode}) => {
	return (
		<ButtonDefault onClick={onClick}>
			{children}
		</ButtonDefault>
	);
};
